import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import { BLACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import SectionCard from '../../positionTemplate/components/SectionCard';
import { certificationOptionsCallback, skillOptionsCallback } from '../api/requirementOptions';
import RequirementPicker from '../components/RequirementPicker';
import { getSectionAnchorId, SECTION_IDS } from '../constants';

const requirementItemShape = PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string });

const RequirementsSection = ({ values, setField }) => {
  const title = LanguageConverterV2('positionTemplate.create.requirements.title');
  const optionalTag = LanguageConverterV2('positionTemplate.create.requirements.optional');

  const requirements = values.requirements || {};

  const updateRequirements = (patch) => setField('requirements', { ...requirements, ...patch });

  return (
    <Box
      id={getSectionAnchorId(SECTION_IDS.REQUIREMENTS)}
      data-testid="requirements-section"
      sx={{ scrollMarginTop: '16px' }}
    >
      <SectionCard
        header={
          <Box sx={{ alignItems: 'baseline', display: 'flex', gap: '8px' }}>
            <Typography sx={{ color: BLACK[100], fontFamily: PRIMARY_FONT[700], fontSize: '14px' }}>
              {title}
            </Typography>
            <Typography sx={{ color: BLACK[60], fontFamily: PRIMARY_FONT[400], fontSize: '12px' }}>
              {optionalTag}
            </Typography>
          </Box>
        }
      >
        <Box sx={{ padding: '8px 0' }}>
          <RequirementPicker
            labelKey="positionTemplate.create.requirements.certifications.label"
            placeholderKey="positionTemplate.create.requirements.certifications.placeholder"
            helperKey="positionTemplate.create.requirements.certifications.helper"
            optionsCallback={certificationOptionsCallback}
            selected={requirements.certifications}
            onChange={(certifications) => updateRequirements({ certifications })}
            testId="position-template-certifications"
          />
          <Divider sx={{ borderColor: BLACK[20], margin: '16px 0' }} />
          <RequirementPicker
            labelKey="positionTemplate.create.requirements.skills.label"
            placeholderKey="positionTemplate.create.requirements.skills.placeholder"
            optionsCallback={skillOptionsCallback}
            selected={requirements.skills}
            onChange={(skills) => updateRequirements({ skills })}
            testId="position-template-skills"
          />
        </Box>
      </SectionCard>
    </Box>
  );
};

RequirementsSection.propTypes = {
  values: PropTypes.shape({
    requirements: PropTypes.shape({
      certifications: PropTypes.arrayOf(requirementItemShape),
      skills: PropTypes.arrayOf(requirementItemShape),
    }),
  }).isRequired,
  setField: PropTypes.func.isRequired,
};

export default RequirementsSection;
